import { graphqlClient } from '../../graphql/graphql'
import { CREATE_ORGANIZER, CREATE_LITE_ORGANIZER, CREATE_ATTENDEE, LOGIN, UPDATE_USER, UPDATE_ORGANIZATON, UPDATE_BANK_DATA, FETCH_DATA_USER  } from '../../graphql/mutations/user'
import { DATA_ORGANIZATIONS, DATA_ORGANIZER, VALIDATION_STATUS } from '../../graphql/queries/user'

import Vue from 'vue'

/**
 * Función para obtener todos los usuarios.
 * @param { object }  context  Objeto que expone los métodos del store (commits, getters, dispatch).
 */
export const fetchOrganizations = async ({commit}) => {
    try {
        let { data: { users } } = await graphqlClient.query({
            query: DATA_ORGANIZATIONS,
            fetchPolicy: 'network-only'
        });
        commit('setOrganizations', users);
        return true;
    } catch (err) {
        return err;
    }
}

/**
 * Función para que un usuario inicie sesión en el sistema.
 * @param { object }  context  Objeto que expone los métodos del store (commits, getters, dispatch).
 * @param { object } loginData Objecto con los datos del usuario a iniciar sesión. 
 */
export const login = async ({ commit }, loginData) => {
    try {
        let { data: { login: { user, token } } } = await graphqlClient.mutate({
            mutation: LOGIN(loginData)
        })
        localStorage.setItem('USER_TOKEN', token);
        commit('setUser', user)
        return user.role
    } catch (e) {
        return false;
    }
}

/**
 * Función para que el usuario solicite un cambio de contraseña (EL EMAIL INGRESADO RECIBE UN CORREO CON LOS PASOS PARA CAMBIAR LA CONTRASEÑA)
 * @param {String} email Email ingresado para recuperar la contraseña
 */
export const fetchDataUser = async ({ commit }, email) => {
    try {
        let { data: { dataUser } } = await graphqlClient.mutate({
            mutation: FETCH_DATA_USER(email)
        })
        return {status: true, message: "El correo ha sido enviado, revisa tu bandeja de entrada 😄"}
    } catch (e) {
        return {status: false, message: e.message}
    }
}

/**
 * Función para crear un usuario, dependiendo del apartado en donde se solicite crear el usuario se crean diferentes tipos de usuarios
 * (Afiliado, Organizador u Organizador Lite)
 * @param {Object} userData Objeto con datos del usuario que se va a crear.
 */
export const createUser = async ({ commit }, userData) => {
    if (userData.type == 'Asistente') {
        let { data: { createAttendee: { user, token } } } = await graphqlClient.mutate({
            mutation: CREATE_ATTENDEE(userData)
        })
        localStorage.setItem('USER_TOKEN', token);
        commit('setUser', user)
        return user.role
    } else if(userData.type == 'Organizador') {
        let { data: { createOrganizer: { user, token } } } = await graphqlClient.mutate({
            mutation: CREATE_ORGANIZER(userData)
        })
        localStorage.setItem('USER_TOKEN', token);
        commit('setUser', user)
        return user.role
    } else {
        let { data: { createLiteOrganizer: { user, token } } } = await graphqlClient.mutate({
            mutation: CREATE_LITE_ORGANIZER(userData)
        })
        localStorage.setItem('USER_TOKEN', token);
        commit('setUser', user)
        return user.role
    }
}

/**
 * Función que permite a los usuarios de tipo ORGANIZADOR WECHAMBER y ORGANIZADOR LITE actualizar su foto de organización.
 * @param {Object} userData Datos del usuario que se va a actualizar.
 */
export const updateUser = async ({ commit }, userData) => {
    try {
        let response = await graphqlClient.mutate({
            mutation: UPDATE_USER(userData)
        })
        return {status: true, message: response}
    } catch (e) {
        return {status: false, message: e.message}
    }
}

/**
 * Función que sirve para actualizar los datos de un usuario de tipo ORGANIZADOR WECHAMBER u ORGANIZADOR LITE.
 * (SOLO FUNCIONA EN EL MÓDULO DE ADMINISTRADOR)
 * (NO SE PUEDE ACTUALIZAR LA CONTRASEÑA NI LA IMAGEN DE LOS USUARIOS)
 * @param {Object} organizationData Objeto que contien los datos del usuario que se va a editar.
 */
export const updateDataOrganization = async ({ commit }, organizationData) => {
    try {
        let response = await graphqlClient.mutate({
            mutation: UPDATE_ORGANIZATON(organizationData)
        })
        return {status: true, message: response}
    } catch (e) {
        return {status: false, message: e.message}
    }
}

/**
 * Función que sirve para actualizar los datos bancarios de una organización
 * (SE ACTIVA UN v-dialog AL MOMENTO DE CREAR EL PRIMER PLAN O EVENTO CON COSTO, EL USUARIO DEBE IGRESAR ESOS DATOS PARA PODER PUBLICAR EL EVENTO/PLAN).
 * @param {*} bankData 
 */
export const updateBankDataOrganization = async ({ commit }, bankData) => {
    try {
        let response = await graphqlClient.mutate({
            mutation: UPDATE_BANK_DATA(bankData)
        })
        return {status: true, message: response}
    } catch (e) {
        return {status: false, message: e.message}
    }
}

//Comprobar que no se usa esta función para posteriormente eliminarla
/*
export async function saveImage(state, file) {
    const formData = new FormData();
    formData.append("file", file);
    let response = await Vue.axios(
        {
            method: 'POST',
            url: '/api/imageUpload',
            data: formData,
        }
    );
    return response.data.urlImg;
}*/

/**
 * Función que obtiene los datos de la organización cuando el usuario esta viendo un calendario de eventos.
 * @param {String} id Identificador de un usuario de tipo organización.
 */
export const fetchDataOrganizer = async ({ commit }, id) => {
    let { data: { dataCompany } } = await graphqlClient.query({
        query: DATA_ORGANIZER,
        variables: { id },
        fetchPolicy: 'network-only'
    })
    commit('setDataCompany', dataCompany)
    return dataCompany
}

/**
 * Función para revisar si la información bancaría del usuario de tipo ORGANIZADOR WECHAMBER ya fue validada.
 */
export const checkValidationStatus = async ({ commit }) => {
    let response = await graphqlClient.query({
        query: VALIDATION_STATUS,
    })
    return response.data;
}